import { ExceptionsService } from "../services/utelize/general/exceptions-service";
import { MdmUserDomainOther } from "../consts";

export function mdmUserDomainsDisplayText(exceptionsService: ExceptionsService,
                                          userDomains      : string | null | undefined
                                         ): string {
  try {
    if (!userDomains)
      return '';

    return userDomains
           .split(',')
           .map(d => d===MdmUserDomainOther ? 'Other' : d)
           .join(', ');
  }
  catch(e) {
    exceptionsService.handleException(<Error>e);
    return '';
  }
}
